import { render, staticRenderFns } from "./QuickFilterItem.vue?vue&type=template&id=9b817920"
import script from "./QuickFilterItem.vue?vue&type=script&lang=js"
export * from "./QuickFilterItem.vue?vue&type=script&lang=js"
import style0 from "./QuickFilterItem.vue?vue&type=style&index=0&id=9b817920&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports